import { usersSlice } from './slice';

export const usersReducer = usersSlice.reducer;
export * from './actions';
export * from './store';
